module.exports = __webpack_public_path__ + "img/readMessages.5623ea19.svg";